// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"B_TheComp__CTUF7"};